<template>
  <div class="home">
    <nav-bar>
      <div class="menu">
        
      </div>
    </nav-bar>
    <div class="main-content">
      <action-bar class="header" :filter.sync="filter" :sort-by.sync="sortBy" :asc.sync="asc" :new-event-action="openNewEventDialog" />
      <el-table
    :data="tableData4"
    style="width: 100%"
    >
    <el-table-column
      fixed
      prop="date"
      label="Date"
      width="150">
    </el-table-column>
    <el-table-column
      prop="name"
      label="Name">
    </el-table-column>
    <el-table-column
      prop="state"
      label="State">
    </el-table-column>
    <el-table-column
      prop="city"
      label="City"
      width="120">
    </el-table-column>
    <el-table-column
      prop="address"
      label="Address"
      width="300">
    </el-table-column>
    <el-table-column
      prop="zip"
      label="Zip">
    </el-table-column>
    <el-table-column
      fixed="right"
      width="150"
      label="Operations">
      <template slot-scope="scope">
        <el-button
          type="text"
          size="small">
          Details
        </el-button>
      </template>
    </el-table-column>
  </el-table>
    </div>

    <el-dialog
    :visible.sync="dialogNewEvent"
    :before-close="closeNewEventDialog"
    title="Ajouter une nouvelle dépense">
    <div class="dialog-content">
      <div class="title-wrapper">
        <div class="title-input">
          <p>Exemple de champ text court</p>
          <input class="input-c" name="title" :maxlength="MAX_TITLE_LENGTH" :placeholder="`${MAX_TITLE_LENGTH} caractères maximum`" type="text" v-model="title">
        </div>
      </div>
      <div class="content-wrapper">
        <div class="inline-group">
          <div class="input-group">
            <div class="input-label">Exemple de champ date:</div>
            <el-date-picker
              class="input-c"
              v-model="dateStart"
              type="datetime"
              placeholder="Select date and time">
            </el-date-picker>
          </div>
          <!-- <div class="input-group">
            <div class="input-label">Event type:</div>
          </div> -->
        </div>
        <div class="input-group">
          <div class="input-label">Exemple de champ text long:</div>
          <textarea class="input-c" v-model="description" :placeholder="`${MAX_DESCRIPTION_LENGTH} caractères maximum`" :maxlength="MAX_DESCRIPTION_LENGTH"></textarea>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <div class="btn-c" type="primary" @click="createEvent()">Envoyer</div>
    </div>
  </el-dialog>
  </div>
</template>

<script>
import { Component, BaseComponent, Action, Getter } from '@/libs/BaseComponent'
import Navbar from '@/modules/shared/nav/navbar/_views/Navbar'
import ActionBar from '@/modules/home/_components/ActionBar'
import EventsList from '@/modules/home/_components/EventsList'

@Component({
  components: {
    'nav-bar': Navbar,
    'action-bar': ActionBar,
    'events-list': EventsList
  }
})
export default class Home extends BaseComponent {
  filter = ''
  sortBy = 'created_at'
  asc = true
  kebab = 1

  // event rules
  MAX_TITLE_LENGTH = 24
  MAX_DESCRIPTION_LENGTH = 40

  // dialog new event var
  dialogNewEvent = false
  title = ''
  dateStart = ''
  description = ''

  tableData4= [{
          date: '2016-05-03',
          name: 'Tom',
          state: 'California',
          city: 'Los Angeles',
          address: 'No. 189, Grove St, Los Angeles',
          zip: 'CA 90036'
        }, {
          date: '2016-05-02',
          name: 'Tom',
          state: 'California',
          city: 'Los Angeles',
          address: 'No. 189, Grove St, Los Angeles',
          zip: 'CA 90036'
        }, {
          date: '2016-05-04',
          name: 'Tom',
          state: 'California',
          city: 'Los Angeles',
          address: 'No. 189, Grove St, Los Angeles',
          zip: 'CA 90036'
        }, {
          date: '2016-05-01',
          name: 'Tom',
          state: 'California',
          city: 'Los Angeles',
          address: 'No. 189, Grove St, Los Angeles',
          zip: 'CA 90036'
        }, {
          date: '2016-05-08',
          name: 'Tom',
          state: 'California',
          city: 'Los Angeles',
          address: 'No. 189, Grove St, Los Angeles',
          zip: 'CA 90036'
        }, {
          date: '2016-05-06',
          name: 'Tom',
          state: 'California',
          city: 'Los Angeles',
          address: 'No. 189, Grove St, Los Angeles',
          zip: 'CA 90036'
        }, {
          date: '2016-05-07',
          name: 'Tom',
          state: 'California',
          city: 'Los Angeles',
          address: 'No. 189, Grove St, Los Angeles',
          zip: 'CA 90036'
        }]

  @Getter('entities/events/allEvents') get allEvents () {}

  get trucComputed () {
    return parseInt(this.kebab) * 2
  }
  get eventsComputed () {
    if (!this.allEvents) return []
    let tmp = this.allEvents.filter(event => (!this.filter || (event && event.title && event.title.toLowerCase().indexOf(this.filter.toLowerCase()) !== -1)))
    let sortBy = this.sortBy
    return tmp.sort(function (a, b) {
      if (a && b && a[sortBy] < b[sortBy]) { return -1 }
      if (a && b && a[sortBy] > b[sortBy]) { return 1 }
      return 0
    })
  }

  @Action('entities/events/addEvent') addEvent () {}
  @Action('entities/events/ensureEvents') ensureEvents () {}

  async createEvent () {
    if (this.title.length === 0) {
      this.createEventError('You need to set a title to your event')
      return
    }
    if (this.title.length > this.MAX_TITLE_LENGTH) {
      this.createEventError(`Max length of title is ${this.MAX_TITLE_LENGTH}, your is ${this.title.length}`)
      return
    }
    if (!this.dateStart) {
      this.createEventError(`You need to set a starting date to your event`)
      return
    }
    if (!this.description) {
      this.description = this.title
    }
    if (this.description.length > this.MAX_DESCRIPTION_LENGTH) {
      this.createEventError(`Max length of description is ${this.MAX_DESCRIPTION_LENGTH}, your is ${this.description.length}`)
      return
    }
    const result = await this.addEvent({
      dateStart: this.dateStart,
      title: this.title,
      description: this.description
    })

    if (result && result.success === true) {
      this.dialogNewEvent = false
      this.$message({
        message: 'Event added with success',
        type: 'success',
        showClose: true
      })
      this.resetDialogNewEvent()
    }
    if (result && result.error) {
      this.createEventError(`An error has occured`)
    }
  }

  createEventError (message) {
    this.$notify({
      type: 'error',
      title: 'Create event error',
      message
    })
  }

  openNewEventDialog () {
    this.dialogNewEvent = true
  }

  closeNewEventDialog (done) {
    this.resetDialogNewEvent()
    done()
    this.dialogNewEvent = false
  }

  resetDialogNewEvent () {
    this.title = ''
    this.dateStart = Date.now()
    this.description = ''
  }
}
</script>

<style lang="scss" scoped>
  .home {
    display: flex;
    flex-direction: column;
    overflow:hidden;

    .menu {
      height:100%;
      padding-left: 20px;
      display: flex;
      align-items: center;
      font-size: 16px;
    }

    .main-content {
      display: flex;
      flex-direction: column;
      width: 100%;
      height: calc(100vh - 148px);
      padding:0 20px 0 20px;

      .header {
        height: 60px;
        margin-bottom:20px;
      }

    }
    .dialog-content {
      display: flex;
      flex-direction: column;
      width: 100%;
      .title-wrapper {
        display: flex;
        padding: 0px 0px 20px 6px;
        margin-bottom: 20px;
        border-bottom: 0.5px solid rgba(150,150,150,0.7);

        .event-img {
          background-image: radial-gradient(circle, #fb7c0a, #f82a51);
          box-shadow: 0px 0px 1px #aaa;
          height:90px;
          width: 160px;
        }
        .title-input {
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          align-items: left;
          padding: 0px 0px 0px 12px;
          flex: 1;

          .input-c {
            margin-top: -4px;
            width: 100%;
          }
          p {
            font-size: 16px;
          }
        }
      }
      .content-wrapper {
        display: flex;
        flex-direction: column;
      }
      .inline-group {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom:12px;
        width: 100%;
      }
      .input-group {
        width: 100%;

        .input-c {
          width: 100%;
        }
        .input-label {
          padding: 6px;
        }
      }
    }

    .dialog-footer {
      display: flex;
      align-items: center;
      justify-content: center;

      .btn-c{
      padding: 10px 20px 10px 20px;
      background: #fdd318;
      border-radius: 8px;
      color: #222;
      cursor: pointer;

      &:hover {
        filter: brightness(120%);
      }
    }
    }
  }
</style>

<style lang="scss">
  .home {

    .input-group {
        .el-input__inner {
          background: #272b2e;
          color: #fff;
          width: 100%;
          border: none;
        }
      }
  }
</style>
